export const INVOICE_LIST_REQUEST   = 'INVOICE_LIST_REQUEST';
export const INVOICE_LIST_SUCCESS   = 'INVOICE_LIST_SUCCESS';
export const INVOICE_LIST_FAIL      = 'INVOICE_LIST_FAIL';
export const INVOICE_LIST_UPDATE    = 'INVOICE_LIST_UPDATE';